import React from "react";
import {
  Label,
  Input,
  Field,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import InfoButton from "../GenericComponent/InfoButton";

export default function QueueSLA(props) {
  const { t } = useTranslation();

  return (
    <div className="add-queue-root" >
      <Field label={
        <>
          {t("SLA")}
          <InfoButton infoKey="SLA" category="QUEUES" />
        </>
      } className="queue-form-field" style={{ maxWidth: "50%",marginLeft:'25%' }}>
        <Label weight="semibold" className="queue-form-sla">
          {t("SLA_IN_SECONDS")}
        </Label>
        <Input
          type="number"
          placeholder={t("SECONDS_PLACEHOLDER")}
          min={0}
          value={props.queue?.sla}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(event, data) => {
            props.setQueue({
              ...props.queue,
              sla: data.value,
            });
          }}
          className="queue-form-input-inline"
          style={{ width: "100%" }}
        />
        <Label className="queue-form-sla" weight="semibold">
          {t("SLA_THRESHOLD_PERCENT")}
        </Label>
        <Input
          type="number"
          placeholder={t("PERCENT_PLACEHOLDER")}
          min={0}
          max={100}
          value={props.queue?.slaThreshold}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(event, data) => {
            props.setQueue({
              ...props.queue,
              slaThreshold: data.value,
            });
          }}
          className="queue-form-input-inline"
          style={{ width: "100%" }}
        />
      </Field>
    </div>
  );
}
